import styled from "styled-components";

export const ContractSelectorWrapper = styled.div`
  border: 1px solid #b1b3b3;
  border-radius: 8px;

  box-sizing: border-box;
  * {
    box-sizing: border-box;

    color: #4d4d4d;
  }

  .body {
    max-height: 95px;
    overflow: auto;

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
      opacity: 0.7;
    }

    &::-webkit-scrollbar {
      width: 12px;
      background-color: #f5f5f5;
      opacity: 0.7;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: rgba(0, 0, 0, 0.2);
      opacity: 0.5;
    }
  }

  .title {
    display: flex;
    align-items: center;
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    color: #4d4d4d;
    height: 45px;
    padding: 8px 16px;
    background-color: #e8e8e8;
    border-radius: 8px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .contract {
    display: flex;
    align-items: center;

    border-top: 1px solid #b1b3b3;
    padding: 8px 16px;

    label,
    input {
      cursor: pointer;
    }
    input {
      margin-right: 6px;
    }
  }

  .contract-checked {
    color: ${(props) => props.tema.primaryColor};
    font-weight: 600;
    font-size: 16px;

    input[type="radio"] {
      accent-color: ${(props) => props.tema.primaryColor};
    }
  }

  @media (max-width: 720px) {
    .title {
      padding: 32px 16px;
    }
  }
`;
